import { Checkbox, Text } from "@mantine/core";
import Link from "next/link";

import { UnviewedIndicatorText } from "@/components/ui/unviewed-indicator-text";
import { useTrackAnalytics } from "@/hooks/analytics.hooks";
import type { ScreenerLocation } from "@/types/screener-location";
import type { PropsWithTableInfo } from "@/types/third-party";
import { locationHasCompletedSessions } from "@/utils/screener-location.utils";

export const LocationNameCell = ({
  info,
}: PropsWithTableInfo<ScreenerLocation, string>) => {
  const row = info.row.original;
  const track = useTrackAnalytics();

  return (
    <div className="flex items-center gap-3">
      <Checkbox
        onClick={(e) => {
          e.stopPropagation();
        }}
        checked={info.row.getIsSelected()}
        onChange={info.row.getToggleSelectedHandler()}
        disabled={!info.row.getCanSelect()}
        className="flex-shrink-0"
      />
      {/* Avoid linking to locations without any screener sessions as they will 404. */}
      {locationHasCompletedSessions(row) ? (
        <Link
          href={`/screener-location/${row.id}`}
          className="flex-grow min-w-0"
          onClick={(e) => {
            e.stopPropagation();
            track("Position Clicked", {
              screener_location_id: row.id,
            });
          }}
        >
          <div className="flex-grow min-w-0 mt-1">
            <UnviewedIndicatorText
              indicatorText={`${row.unviewedSessionCount}`}
              primaryText={info.getValue()}
              showIndicatorText={row.unviewedSessionCount > 0}
            />
          </div>
        </Link>
      ) : (
        <Text size="sm">{info.getValue()}</Text>
      )}
    </div>
  );
};
